export default __webpack_public_path__ + "static/media/right gloves.776d1683.png";